<template>
  <header>
    <b-navbar class="container" :mobile-burger="false">
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            src="~@/assets/images/logo_extended_orange.svg"
            alt="Rede SARAH de Hospitais de Reabilitação - Associação das Pioneiras Sociais"
          />
        </b-navbar-item>
        <h1>{{ title }}</h1>
      </template>
    </b-navbar>
  </header>
</template>

<script>
export default {
  name: 'FormHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
header {
  box-shadow: -0px 0px 14px 0px $neutral-color-4;
  position: relative;

  background: var(--bg-color-primary);
  min-height: 6.25rem;
  padding-top: 1.5625rem;
  .navbar-item.router-link-active {
    max-width: 6.7rem;
    overflow: hidden;
    padding: 0;
    img {
      max-width: max-content;
      height: auto;
      width: auto;
      min-width: 18rem;
    }
  }
  h1 {
    text-align: center;
    font-size: 1.625rem;
    font-weight: $font-bold;

    line-height: 2;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    max-width: 38rem;
  }
}
@media (max-width: 60rem) {
  header {
    min-height: 9rem;
    .navbar-brand {
      padding-bottom: 0.15rem;
      border-bottom: 1px solid $neutral-color-4;
      border-color: var(--neutral-color-4);
      h1 {
        font-size: 1.45rem;
        top: 3.75rem;
      }
    }
  }
}
</style>
